// extracted by mini-css-extract-plugin
export default {"parameter":"tkYwh","name":"kh7Sq","imageWrapper":"oYrCK","title":"aUGuF","description":"O_52d"};